import React, { useState } from 'react'
import './PlaceOrders.css'
import { useNavigate } from 'react-router-dom'
import { useUser } from '../../store/UserContext'
import { collection,deleteDoc,doc } from 'firebase/firestore'
import { db } from '../../firebase/Config'
import { addDoc } from 'firebase/firestore'
import { query,where,getDocs,runTransaction } from 'firebase/firestore'
import LoadingForAll from '../../Pages/LoadingForAll'
import { useProducts } from '../../store/ProductContext'

function PlaceOrders() {
    const navigate=useNavigate()
    const {currentUser}=useUser()
    const {updateProduct}=useProducts()

    const [name,setName]=useState(currentUser?.displayName)
    const [email,setEmail]=useState('')
    const [phone,setPhone]=useState('')
    const [address,setAddress]=useState('')
    const [city,setCity]=useState('')
    const [pincode,setPincode]=useState('')
    const [state,setState]=useState('')
    const [loading,setLoading]=useState(false)
    const [error,setError]=useState(null)
    const [agreeTnC,setAgreeTnC]=useState(false)
    
    const handleSubmit=async()=>{
        setLoading(true)
       if(!currentUser){
        setLoading(false)
        navigate('/login')
        return
       }
       if(!name || !email || !phone || !address || !city || !pincode || !state){
        setError('Please fill all the fields')
        setLoading(false)
        return
       }

       try {
        // Get cart items
        const cartQuery = query(collection(db, 'cart'), where('userId', '==', currentUser.uid));
        const cartSnapshot = await getDocs(cartQuery);
        
        if (cartSnapshot.empty) {
            setError('No items in cart');
            setLoading(false);
            return;
        }

        const cartItems = cartSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));

        // First validate stock for all products
       
        // Calculate total amount
        const totalAmount = cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);

        // Create order document
        const orderRef = await addDoc(collection(db, 'orders'), {
            name,
            email,
            phone,
            address,
            city,
            pincode,
            state,
            userId: currentUser.uid,
            orderDate: new Date().toISOString(),
            orderStatus:'Pending',
            productsDetails: cartItems.map((item) => ({ 
                productId: item.productId,
                productName: item.productName,
                productImage: item.imageUrl,
                productPrice: item.price,
                productQuantity: item.quantity,
                productIsShipped: false
            })),
            
            totalAmount: totalAmount,
           
        });

        // Update product stock and totalOrders in a transaction
      
        // Delete cart items
        const deletePromises = cartSnapshot.docs.map(doc => deleteDoc(doc.ref));
        await Promise.all(deletePromises);

        setLoading(false);
        navigate('/orders'); // Consider creating an order success page
    }
    catch(error){
        console.error('Error adding order:',error)
        setError(error.message)
        setLoading(false)
    }       
}

  return (
    <div className="place-order-page">
      <div className="place-order-container">
        <div className="place-order-header">
          <div className="header-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h1>Complete Your Order</h1>
          <p>Please provide your genuine shipping information to proceed</p>
        </div>
        
        <div className="place-order-content">
          

          <div className="place-order-form">
            <div className="form-section">
              <h2>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
                  <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45768C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Personal Information
              </h2> <br />
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Full Name</label>
                  <input 
                    type="text" 
                    id="name" 
                    name="name" 
                    
                    value={currentUser?.displayName}
                    onChange={(e)=>setName(e.target.value)}
                    placeholder="Enter your full name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">G-mail Address</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    
                    value={email}
                    onChange={(e)=>setEmail(e.target.value)}    
                    placeholder="Enter your G-mail"
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input 
                  type="tel" 
                  id="phone" 
                  name="phone" 
                  value={phone}
                  onChange={(e)=>setPhone(e.target.value)}
                  placeholder="Enter your phone number"
                />
              </div>
            </div>

            <div className="form-section">
              <h2>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 10C21 17 12 23 12 23S3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2"/>
                </svg>
                Shipping Address
              </h2>
              <div className="form-group">
                <label htmlFor="address">Street Address</label>
                <textarea 
                  id="address" 
                  name="address" 
                  value={address}
                  onChange={(e)=>setAddress(e.target.value)}
                  placeholder="Enter your complete street address"
                  rows="3"
                />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="city">City</label>
                  <input 
                    type="text" 
                    id="city" 
                    name="city" 
                    value={city}
                    onChange={(e)=>setCity(e.target.value)}
                    placeholder="Enter city"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="pincode">PIN Code</label>
                  <input 
                    type="text" 
                    id="pincode" 
                    name="pincode" 
                    value={pincode}
                    onChange={(e)=>setPincode(e.target.value)}
                    placeholder="Enter PIN code"
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="country">State</label>
                <select 
                  id="country" 
                  name="country" 
                  value={state}
                  onChange={(e)=>setState(e.target.value)}
                >
                  <option value="">Select your State</option>
                  <option value="Kerala">Kerala</option>
                  <option value="Tamil Nadu">Tamil Nadu</option>
                  <option value="Karnataka">Karnataka</option>
                  <option value="Maharashtra">Maharashtra</option>
                  
                </select>
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={()=>navigate('/cart')}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 12H5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 19L5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Back to Cart
              </button>
              <div className="tnc-card">
                <h3 className="tnc-title">Terms & Conditions</h3>
                <p className="tnc-text">
                  By placing an order, we will contact you within 24 hours to confirm your order through Instagram, Email, or WhatsApp.
                </p>
                <div className="tnc-checkbox-row">
                  <input
                    type="checkbox"
                    id="agreeTnC"
                    checked={!!agreeTnC}
                    onChange={e => setAgreeTnC(e.target.checked)}
                  />
                  <label htmlFor="agreeTnC" className="tnc-checkbox-label">
                    I have read and agree to the Terms & Conditions
                  </label>
                </div>
              </div>
              {error && <p className="error-message">{error}</p>}
              {loading && <LoadingForAll text='Placing Order'/>}
              <button type="submit" className="btn-primary" onClick={handleSubmit} disabled={!agreeTnC}>
                Place Order
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 5L19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PlaceOrders